import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Breadcrumb, BreadcrumbItem, Button } from '@carbon/react';
import { Printer } from '@carbon/react/icons';

import { routes } from 'core/routing';
import DashboardComparisonCard from 'features/dashboard/components/DashboardComparisonCard';
import Dashboard from 'features/dashboard/Dashboard';
import styles from 'theme/features/dashboard/dashboard-comparison.module.scss';

const DashboardComparison = ({ data: [leftDashboard, rightDashboard] }) => {
  const navigate = useNavigate();

  const handleNavigateToAllProjects = (e) => {
    e.preventDefault();
    navigate(routes.allProjects());
  };

  return (
    <div>
      <header className={styles.header}>
        <Breadcrumb className={styles.breadcrumbs}>
          <BreadcrumbItem href={routes.allProjects()} onClick={handleNavigateToAllProjects}>
            All Projects
          </BreadcrumbItem>
          <BreadcrumbItem isCurrentPage>Comparison</BreadcrumbItem>
        </Breadcrumb>
        <Button
          hasIconOnly
          renderIcon={Printer}
          onClick={() => window.print()}
          iconDescription="Print preview"
          className={styles['print-button']}
          kind="ghost"
          size="sm"
          tooltipPosition="bottom"
        />
      </header>
      <div className={styles.wrapper}>
        <DashboardComparisonCard>
          <Dashboard {...leftDashboard} compact />
        </DashboardComparisonCard>
        <DashboardComparisonCard isRightSide>
          <Dashboard {...rightDashboard} compact />
        </DashboardComparisonCard>
      </div>
    </div>
  );
};

export default DashboardComparison;
